"use client";

import { RefObject, useEffect } from "react";

type UseMutationObserverOptions = {
  targetRef: RefObject<HTMLElement | null>;
  onMutation: (mutations: MutationRecord[], observer: MutationObserver) => void;
  options?: MutationObserverInit;
};

export function useMutationObserver({
  targetRef,
  onMutation,
  options = { childList: true },
}: UseMutationObserverOptions) {
  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      onMutation(mutations, observer);
    });

    observer.observe(target, options);

    return () => observer.disconnect();
  }, [targetRef, onMutation, options]);
}
